
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
class Quote extends Vue {
}

export default Quote;
